import React, { useMemo } from "react";
import style from "./index.module.scss";
import TipStuList from "../TipStuList";
import { EndExerciseOptionModel } from "service/question";
import { useAtomValue } from "jotai";
import { exerciseInfoAtom, staticsAtom } from "service/stores/Question/Statics";
import { indexToChar } from "../../../../../../utils/common";
import { isTrue } from "../../../../../../service/service";

interface ExerciseStaticsOptionProps {
    data: EndExerciseOptionModel;
    index: number;
}

export default function ExerciseStaticsOption({
    data,
    index
}: ExerciseStaticsOptionProps) {
    const { stuCount } = useAtomValue(staticsAtom);
    const exerciseInfo = useAtomValue(exerciseInfoAtom);

    const percent = useMemo(() => {
        if (!stuCount) return 0;
        return `${((data.stuOptionInfos?.length || 0) * 100) / stuCount}%`;
    }, [stuCount, data.stuOptionInfos?.length]);

    return (
        <div className={style.root}>
            <div className={style.main}>
                <em className={style.index}>{indexToChar(index)}</em>
                <div
                    className={style.description}
                    dangerouslySetInnerHTML={{ __html: data.description }}
                />
            </div>

            <div className={style.percent}>
                <div className={style.inner} style={{ width: percent }} />

                {isTrue(exerciseInfo.anonymityFlag) && (
                    <span className={style.count}>
                        {data.stuOptionInfos?.length || 0}人
                    </span>
                )}

                {!isTrue(exerciseInfo.anonymityFlag) && (
                    <TipStuList stuList={data.stuOptionInfos || []}>
                        <div className={style.count}>
                            ({data.stuOptionInfos?.length || 0}人)
                        </div>
                    </TipStuList>
                )}
            </div>
        </div>
    );
}
